import React from "react"
import "./styles.scss"

import Header from "../../../../components/Header"
import Footer from "../../../../components/Footer"
import Button from "../../../../components/Button"
import iconReview from "./images/icon-review.svg"

const Almost = () => {
  return (
    <div className="main-container main-container--dark">
      <Header theme="light" hideNotifications />

      <div className="content welcome">
        <div className="content_section_header">
          <div className="container">
            <div className="row">
              <div className="col-md-6 offset-md-3">
                <h1 className="content_section_title">You Are Almost Done!</h1>

                <div className="content_section_icon">
                  <img src={iconReview} title="Almost Done" alt="Almost Done" />
                </div>

                <h1 className="content_section_title">
                  Please review your pre-plan to ensure that all sections are
                  complete and you have provided information that you are
                  prepared to share with others.
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <Button
                routerLink={{
                  to: "/pre-plan/review"
                }}
                className="btn--secondary-light btn--width-full btn--height-lg btn--font-size-sm"
              >
                Review My Pre-Plan
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Almost
